import { Link } from 'react-router-dom';

export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0a0a0f] border-t border-gray-800 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1">
            <img src="/logo.png" alt="Kuze Logo" className="h-10 w-auto mb-4" />
            <p className="text-gray-400 text-sm">
              Built for real rooms. Real people. Real nights.
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6">
            <Link
              to="/privacy"
              className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-gray-400 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Terms
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <p className="text-gray-500 text-sm text-center">
            © 2026 Think Heart Apps AB · KUZE - Built for real-life parties.
          </p>
        </div>
      </div>
    </footer>
  );
}
